import React, { Fragment } from 'react';
import Api from '../../api/api';
import DinamicTable from '../common/dinamic-table';
import OverlayLoading from '../common/overlay-loading';

export default class Addresses extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        }
    }

    componentDidMount = () => {
        this.updateTable();
    }

    updateTable = async () => {
        await this.setState({ loading: true });
        let req = await Api.get('balance');
        if (!req.error) {
            let rows = req.data;
            console.log(rows)
            let cols = [
                'Name',
                'Address',
                'Amount',
                'Value'
            ]
            rows = rows.map(row => {
                return [
                    row.name,
                    row.address,
                    `${row.balance.toFixed(2)} BNB`,
                    `${(row.bnbPrice * row.balance).toFixed(2)} USD`,
                ]
            })
            this.table.updateTable(cols, rows);
        }
        await this.setState({ loading: false });
    }

    render() {
        return (
            <Fragment>
                <OverlayLoading show={this.state.loading} />
                <div className="container-fluid pt-5">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col">
                                            <h5>Wallets</h5>
                                        </div>
                                    </div>
                                </div>
                                <DinamicTable
                                    size="5"
                                    ref={ref => this.table = ref}
                                    openRow={this.openRow}
                                    deleteRow={this.deleteRow}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}